module.exports = __webpack_public_path__ + "static/media/preview_screen9.6c648b57.png";